/**
 * 404 页面公共配置
 * 所有品牌共享的文案
 */

export const commonTexts = {
  pageNotFound: 'Page not found',
  goToHomePage: 'Go to Home Page',
} as const
